import React, { useState} from 'react';
import './Login.css';
import { Button,Form, Icon } from 'semantic-ui-react';
import {Link, useHistory} from "react-router-dom";
import 'semantic-ui-css/semantic.min.css';
import { auth } from '../Auth/FirebaseConfig';
 

const Login = () => {
  document.title = `Aisbook by Alif | Login`;

  const history = useHistory("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const authLogin = (e) => {
      e.preventDefault();
      auth.signInWithEmailAndPassword(email, password)
      .then(  (auth) => {
        history.push("/");
      })
      .catch( e => {
        if ( e.message === "The password is invalid or the user does not have a password."
        ) { alert('Please check your password again');
        }
         else if ( e.message === "There is no user record corresponding to this identifier. The user may have been deleted."
        ) { alert("There is no user record Please register now");
          history.push("/register");
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: "smooth",
          });
        } else {
          alert(e.message);
        }
      });
  };
 
     // <Button className='w-100 bttn' onClick={handleGoogleSignIn}><Icon name="google"/>Gmail login</Button>
  // const handleGoogleSignIn = () => {
  //   auth.signInWithPopup(provider)
  //   .then( (result) => {
  //     // console.log(result)      
      
  //     //const {displayName, email,photoURL,uid} = result.user;
  //   //  setLoggedInUser({displayName, email,photoURL,uid})
  //       history.push("/");
  //   })
  //   .catch(error => {
  //     const {errorCode, errorEmail,errorMessage} = error;
  //     // var errorCode = error.code;
  //     // var errorMessage = error.message;
  //     // var email = error.email;
  //     console.log(errorCode,errorMessage,errorEmail);
  //   })      
  // }; 
 
    return (
           <div className="row login">
               <div className="col-md-6 col-sm-4 name">
                 <p className='Fname'>facebook</p>
                 <h1>Facebook helps you connect and share with the people in your life.</h1>
               </div>
               <div className="col-md-3 col-sm-3 logInput">
                 <Form>
                 <Form.Field>
                 <input type="text" placeholder='Email address or phone number' onChange={(e) => setEmail(e.target.value)}/>
                 </Form.Field>
                 <Form.Field>
                 <input type="password" name="" id="" placeholder='Password' onChange={ e => setPassword(e.target.value)}/>
                 </Form.Field>
                 <Button type="submit" className="w-100 mb-3 bttn" onClick={authLogin}><Icon name="log out"></Icon> Login</Button>
                 <a href="#/">Forgotten password?</a>
                 <hr/>
                 <Link to="/register" style={{ textDecoration: 'none' }}>
                    <Button className='w-100 mb-3 bttn'><Icon name="add"/>Create New Account</Button>
                 </Link>
               </Form>
               </div>
           </div>
    );
};
export default Login;
